<!-- TEMPLATE -->
<template>
  <div class='profile-user-details'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-remove-restore
              v-if="$route.name === 'profile.user.edit'"
              slot="title-items"
              :is-removed="isDeleted"
              text-remove="Verwijderen" :remove-icon="trashIcon" @remove="deleteUser"
              text-restore="Herstellen" :restore-icon="lockOpenIcon" @restore="restoreUser"
      >
      </dean-section-title-remove-restore>
      <dean-section-title-item
              v-if="!isDeleted"
              :icon='saveIcon'
              slot="title-items"
              :content="true"
              :large="true"
              @click.native="processUser"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <dean-form-row id="givenName" v-model="userData.personalName.givenName" label="Voornaam" @input="inputFieldChanged"
                       :disabled="isDeleted"
                       :required-field="true" :warning="$v.data.personalName.givenName.$error"
                       @focus="$v.data.personalName.givenName.$touch()"></dean-form-row>
        <dean-form-row id="surnamePrefix" v-model="userData.personalName.surnamePrefix" label="Tussenvoegsels"
                       :disabled="isDeleted"
                       @input="inputFieldChanged"></dean-form-row>
        <dean-form-row id="surname" v-model="userData.personalName.surname" label="Achternaam" @input="inputFieldChanged"
                       :disabled="isDeleted"
                       :required-field="true" :warning="$v.data.personalName.surname.$error"
                       @focus="$v.data.personalName.surname.$touch()"></dean-form-row>
        <dean-form-row id="jobTitle" v-model="userData.personalName.jobTitle" label="Functietitel"
                       :disabled="isDeleted"
                       @input="inputFieldChanged"></dean-form-row>
        <dean-form-row id="phoneNumber" v-model="userData.phoneNumber" label="Telefoonnummer"
                       :disabled="isDeleted"
                       @input="inputFieldChanged"></dean-form-row>
        <dean-form-row id="emailAddress" v-model="userData.emailAddress" label="E-mailadres"
                       @input="inputFieldChanged"
                       :disabled="disableEmailAddressField || isDeleted"
                       :required-field="true" :warning="$v.data.emailAddress.$error"
                       @focus="$v.data.emailAddress.$touch()"></dean-form-row>
      </div>
      <div class="column" slot="right">
        <dean-input-switch-form-row v-if="actionForIsPartnerManagerField !== 'none'"
                                    id="isPartnerManager" :value="userData.isPartnerManager"
                                    @checked="isPartnerManagerChanged"
                                    :disabled="actionForIsPartnerManagerField === 'read' || isDeleted"
                                    label="Is partnermanager"></dean-input-switch-form-row>
        <dean-multi-select-form-row :multiple="true" placeholder="Kies rollen"
                                    id='generic.Roles'
                                    label='Rollen'
                                    :required-field="true"
                                    :disabled="isDeleted"
                                    :warning="$v.data.roles.$error"
                                    :value="selectedRoles"
                                    :options='userAvailableRolesList'
                                    @select='addRole'
                                    @remove="removeRole"></dean-multi-select-form-row>
        <dean-input-switch-form-row id="receivesInvoices" :value="userData.receivesInvoices"
                                    @checked="inputSwitchChanged"
                                    :disabled="isDeleted"
                                    label="Ontvangt facturen"></dean-input-switch-form-row>
        <dean-input-switch-form-row id="receivesNotifications" :value="userData.receivesNotifications"
                                    @checked="inputSwitchChanged"
                                    :disabled="isDeleted"
                                    label="Ontvangt berichten"></dean-input-switch-form-row>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import vSelect from 'vue-select';
  import axios from 'axios';
  import {deanDialogBus} from '@/main';
  import {validationMixin} from 'vuelidate';
  import {required, email} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification, validationMessage} from '@/mixins/validations';

  import {
    customerIcon,
    businessIcon,
    commissionIcon,
    partnerIcon,
    deanAlertDialog,
    deanIcon,
    deanInputField,
    deanSearchField,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    invoicesIcon,
    messageIcon,
    offersIcon,
    ordersIcon,
    returnIcon,
    saveIcon,
    summeryIcon,
    usersIcon,
    lockOpenIcon,
    trashIcon,
    warningIcon,
  } from '@deanone/dean-components';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import DeanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
  import DeanMultiSelectFormRow from '@/components/deanComponents/deanMultiSelectFormRow.vue';
  import deanSectionTitleRemoveRestore from '@/components/deanComponents/deanSectionTitleRemoveRestore.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import sideMenuProfileMixin from '@/mixins/sideMenuProfileMixin';
  import {mixins} from 'vue-class-component';

  @Component({
    components: {
      deanSectionTitleRemoveRestore,
      DeanMultiSelectFormRow,
      DeanInputSwitchFormRow,
      DeanSelectFormRow,
      deanAlertDialog,
      deanInputField,
      DeanTwoColumnLayout,
      deanInputSelect,
      deanFormRow,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      vSelect,
      invoicesIcon,
      deanIcon,
      returnIcon,
      saveIcon,
      summeryIcon,
      partnerIcon,
      businessIcon,
      usersIcon,
      offersIcon,
      ordersIcon,
      commissionIcon,
      messageIcon,
    },
    mixins: [validationMixin],
  })

  export default class Details extends mixins(sideMenuProfileMixin) {
    public params: any = {};
    public saveIcon: object = saveIcon;
    public lockOpenIcon: object = lockOpenIcon;
    public trashIcon: object = trashIcon;
    public roleOptions: object[] = [];
    public data: {
      personalName: {
        givenName: any,
        surnamePrefix: any,
        surname: any,
        jobTitle: any,
      },
      id: any,
      organizationId: any,
      phoneNumber: any,
      emailAddress: any,
      isUser: boolean,
      isPartnerManager: any,
      roles: any,
      receivesInvoices: any,
      receivesNotifications: any,
    } = {
      personalName: {
        givenName: null,
        surnamePrefix: null,
        surname: null,
        jobTitle: null,
      },
      id: null,
      organizationId: null,
      phoneNumber: null,
      emailAddress: null,
      isUser: true,
      isPartnerManager: false,
      roles: [],
      receivesInvoices: false,
      receivesNotifications: false,
    };
    public isDeleted: boolean = false;
    public availableRoles: any[] = [];
    public roles: any[] = [];
    public userEmailAddress: string = '';

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          personalName: {
            surname: {required},
            givenName: {required},
          },
          emailAddress: {required, email},
          roles: {required},
        },
      };
    }

    get userData() {
      return this.data;
    }

    get userAvailableRolesList() {
      return this.availableRoles;
    }

    get headerTitle(): string {
      return (this.$route.params.id !== undefined) ? 'Gebruiker wijzigen' : 'Gebruiker toevoegen';
    }

    get user() {
      return this.$store.getters.getUser;
    }

    get actionForIsPartnerManagerField() {
      if (this.user.organization.isProvider) {
        if (this.user.roles.includes('root')) {
          return 'edit';
        }

        if (
          this.user.roles.includes('businessadmin')
          ||
          this.user.roles.includes('Billing mngr')
        ) {
          return 'read';
        }
      }

      return 'none';
    }

    get disableEmailAddressField() {
      if (this.$route.params.id !== undefined) {
        return true;
      } else {
        return false;
      }
    }

    get selectedRoles() {
      this.updateAvailableRoleOptions();
      return this.data.roles;
    }

    public inputSwitchChanged(field: { id: any, value: any }) {
      const key: string = field.id;
      // @ts-ignore-next-line
      this.data[key] = field.value;
    }

    public isPartnerManagerChanged(field: { value: any }) {
      this.data.isPartnerManager = field.value;
    }

    public inputFieldChanged(field: any) {
      const name: string = field.id;
      // @ts-ignore-next-line
      this.data[name] = field.value;
    }

    public addRole(field: any) {
      this.data.roles.push(field);
      this.updateAvailableRoleOptions();
    }

    public removeRole(field: any) {
      this.data.roles = this.data.roles.filter((role: any) => {
        if (role.value !== field.value) {
          return role;
        }
      });
      this.updateAvailableRoleOptions();
    }

    public updateAvailableRoleOptions() {
      if (this.data.roles.length <= 0) {
        this.availableRoles = this.roles;
        return;
      }

      const selectedRoles: any[] = [];

      this.data.roles.forEach((role: any) => {
        selectedRoles[role.value] = role.label;
      });

      this.availableRoles = this.roles.filter((role: any) => {
        if (selectedRoles[role.value] === undefined) {
          return role;
        }
      });
    }

    public userDetails() {
      this.params = {
        contactId: this.$route.params.id,
        organizationId: this.user.organizationId,
      };

      axios.post('/-/trade/api/person.contact.info', this.params)
        .then(
          (userResponse: any) => {
            const userData = userResponse.data;

            this.data = {
              ...this.data, ...{
                personalName: {
                  givenName: userData.personalName ? userData.personalName.givenName : null,
                  surnamePrefix: userData.personalName ? userData.personalName.surnamePrefix : null,
                  surname: userData.personalName ? userData.personalName.surname : null,
                  jobTitle: userData.personalName ? userData.personalName.jobTitle : null,
                },
                phoneNumber: userData.phoneNumber,
                emailAddress: userData.emailAddress,
                isUser: userData.isUser,
                isPartnerManager: userData.isPartnerManager,
                receivesInvoices: userData.receivesInvoices,
                receivesNotifications: userData.receivesNotifications,
              },
            };

            this.data.roles = (userData.roles || []).map((role: any) => {
              return {
                value: role.value,
                label: role.label,
              };
            });

            this.userEmailAddress = userData.userEmailAddress;
            this.isDeleted = userData.deleted;
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        );
    }

    public loadRoles() {
      this.$store.dispatch('setLoadOverlay', true);

      if (
          this.user.organization
          &&
          this.user.organization.isProvider
      ) {
        this.loadRolesFromAdmin();
      } else {
        this.loadRolesFromPartner(this.user.organizationId);
      }
    }

    public loadRolesFromPartner(partnerId: string) {
      const requestData = {
        type: 'partner',
        partnerId,
      };

      axios.post('/-/trade/api/person.roles.list', requestData)
      .then(
        (roleResponse: any) => {
          this.roles = roleResponse.data;
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public loadRolesFromAdmin() {
      const requestData = {
        type: 'business',
      };

      axios.post('/-/trade/api/admin.roles.list', requestData)
        .then(
          (roleResponse: any) => {
            this.roles = roleResponse.data.data.map((role: any) => {
              return {
                value: role.id,
                label: role.name,
              };
            });
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public created() {
      if (this.$route.params.id) {
        this.userDetails();
      }

      this.loadRoles();
      this.buildSideMenuProfile();
    }

    public deleteUser() {
      deanDialogBus.$emit('open', 'DeleteUserDialog', {
        id: this.$route.params.id,
        context: 'profile',
        contextId: this.$store.getters.getUser.organizationId,
        givenName: this.data.personalName.givenName,
        surnamePrefix: this.data.personalName.surnamePrefix,
        surname: this.data.personalName.surname,
      });
    }

    public restoreUser() {
      deanDialogBus.$emit('open', 'DeleteUserDialog', {
        id: this.$route.params.id,
        context: 'profile',
        contextId: this.$store.getters.getUser.organizationId,
        givenName: this.data.personalName.givenName,
        surnamePrefix: this.data.personalName.surnamePrefix,
        surname: this.data.personalName.surname,
        state: 'restoring',
      });
    }

    public processUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);

        const sendData = this.data;
        if (this.$route.params.id) {
          sendData.id = this.$route.params.id;
        }
        sendData.isUser = true;
        sendData.roles = this.data.roles;
        sendData.organizationId = this.$store.getters.getUser.organizationId;

        axios.post('/-/trade/api/person.contact.save', sendData).then(
          (response) => {
            this.$toast({
              icon: saveIcon,
              text: 'Gebruiker opgeslagen',
              theme: 'success',
            });
          },
          (error) => {
            if (error.response.data.errors) {
              let errorText = 'Fout';

              switch (error.response.data.errors[0].code) {
                case 'ERR_EMAIL_NOT_UPDATEABLE':
                  errorText = 'Kan het e-mailadres van een gebruiker niet bijwerken.';
                  break;
                case 'ERR_EMAIL_NOT_AVAILABLE':
                  errorText = 'E-mailadres is niet beschikbaar.';
                  break;
              }

              this.$toast(validationMessage(errorText));
            } else {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            }
          },
        ).finally(() => {
          this.$store.dispatch('setLoadOverlay', false);
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public mounted() {
      deanDialogBus.$on('userStatusChange', () => {
        this.userDetails();
      });
    }

    public destroyed() {
      deanDialogBus.$off('userStatusChange');
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>
